import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../App';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../LanguageContext';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { t } = useLanguage();
  const { resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError(t('resetPassword.errorMissingToken'));
      return;
    }

    if (newPassword.length < 8) {
      setError(t('resetPassword.errorWeakPassword'));
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(t('resetPassword.errorPasswordMismatch'));
      return;
    }

    setLoading(true);

    try {
      await resetPassword(token, newPassword);
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-lang-toggle">
          <LanguageToggle />
        </div>
        <div className="auth-logo">
          <h1>{t('common.appName')}</h1>
          <p>{t('resetPassword.subtitle')}</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <div className="form-field">
            <label htmlFor="newPassword">{t('resetPassword.newPasswordLabel')}</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-field">
            <label htmlFor="confirmPassword">{t('resetPassword.confirmPasswordLabel')}</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loading-spinner" style={{ width: 20, height: 20 }}></span>
                {t('resetPassword.submitting')}
              </>
            ) : (
              t('resetPassword.submit')
            )}
          </button>
        </form>

        <div className="auth-links">
          <p>
            <Link to="/forgot-password">{t('resetPassword.requestNewLink')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
